import { Typography } from '@material-ui/core';
import React from 'react';

export default function WelcomeScreen({ values, onChange }) {
  return <Typography>In wenigen Schritten zu Deinem payactive account.</Typography>;
}
